import { render, staticRenderFns } from "./SurveyOption.vue?vue&type=template&id=789c954c&"
import script from "./SurveyOption.vue?vue&type=script&lang=js&"
export * from "./SurveyOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports